import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { networkRoutes } from './networth/networth-routing.module';
import { stocksChildRoutes } from './stocks/stocks-routing';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'ytmp3',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./ytmp3/ytmp3.component').then((m) => m.Ytmp3Component),
  },
  {
    path: 'fileserver',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./file-server/file-server.component').then(
        (m) => m.FileServerComponent
      ),
  },

  {
    path: 'stocks',
    canActivate: [AuthGuard],
    children: [...stocksChildRoutes],
  },
  {
    path: 'networth',
    canActivate: [AuthGuard],
    children: [...networkRoutes],
  },
  {
    path: 'allpaths',
    canActivate: [AuthGuard],

    loadComponent: () =>
      import('./welcome/welcome.component').then((m) => m.WelcomeComponent),
  },

  { path: '**', redirectTo: 'stocks' },
];
